import { Modal } from "antd";
import React from "react";
import { useSelector } from "react-redux";
import { WARRANTY_STEP } from "../../common/constant";
import { selectInfoWarranty } from "../../redux/reducers/slice/warranty";
import { warrantyServices } from "../../services";
import "./confirmStyle.scss";
import InformationCustomer from "./infoCustomer";
import InformationProduct from "./infoProduct";

const WarrantyConfirm = (props: any) => {
  const infoWarranty = useSelector(selectInfoWarranty);

  const handleConfirm = () => {
    console.log({ ...infoWarranty });

    if (!infoWarranty?.is_activated) {
      warrantyServices.submitActiveWarrantyInfo(infoWarranty, (data, error) => {
        if (data) {
          props.setVisible(true);
        }

        if (error) {
          Modal.error({
            title: "Lỗi",
            content: error.message,
            onOk: () => {
              props.setStep(3);
            },
            okText: "Đóng",
          });
        }
      });
    }
  };
  return (
    <>
      <>
        <InformationProduct />

        <InformationCustomer
          step={
            infoWarranty?.is_activated
              ? WARRANTY_STEP.RESULT
              : WARRANTY_STEP.CONFIRM
          }
          setStep={props.setStep}
          handleConfirm={handleConfirm}
        />
      </>
    </>
  );
};

export default WarrantyConfirm;
